import { AfterViewInit, EventEmitter, OnChanges, OnInit, SimpleChanges, ChangeDetectorRef } from '@angular/core';
import { Category, InventoryManager, Item, MenuManager, OrderManager, Setting } from 'aigens-ng-core';
import { OrderService } from '../../core/services/order.service';
import { TranslateService } from '@ngx-translate/core';
var GridLayoutItem = /** @class */ (function () {
    // tslint:disable-next-line: max-line-length
    function GridLayoutItem(cdr, translateService, inventoryManager, orderService, menuManager) {
        this.cdr = cdr;
        this.translateService = translateService;
        this.inventoryManager = inventoryManager;
        this.orderService = orderService;
        this.menuManager = menuManager;
        this.isSet = false;
        this.addClick = new EventEmitter();
        this.removeClick = new EventEmitter();
        this.settings = this.orderService.getCurrentStoreSetting();
        // console.log(this.settings);
    }
    Object.defineProperty(GridLayoutItem.prototype, "quantity", {
        set: function (quantity) {
            this._quantity = quantity;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GridLayoutItem.prototype, "item", {
        set: function (item) {
            this._item = item;
            this.onChange();
            // console.log('on item change');
        },
        enumerable: true,
        configurable: true
    });
    GridLayoutItem.prototype.ngOnInit = function () {
        // console.log('on item init');
    };
    GridLayoutItem.prototype.onChange = function () {
        try {
            this.isParent = !!(this._item.variations && this._item.variations.length > 0);
            this.isSet = Item.isSet(this.category, this._item);
            this._isSoldout = this.getSoldout();
            this.name = this.getItemName();
            this.isEn = this.translateService.currentLang === 'en';
        }
        catch (e) {
            console.log(e);
        }
    };
    GridLayoutItem.prototype.ngOnChanges = function (changes) {
        // this.isParent = !!(this._item.variations && this._item.variations.length > 0);
        // this.isSet = Item.isSet(this.category, this._item);
        // this.isSoldout = this.getSoldout();
        // console.log('this.isSoldout', this.isSoldout);
        // this.name = this.getItemName();
        // this.isEn = this.translateService.currentLang === 'en';
    };
    GridLayoutItem.prototype.ngAfterViewInit = function () {
    };
    GridLayoutItem.prototype.getItemName = function () {
        var name = this._item.name;
        if (this.isParent) {
            name = this._item.title;
        }
        if (!name || name.length === 0) {
            name = this._item.name;
        }
        return name;
    };
    GridLayoutItem.prototype.getSoldout = function () {
        var result;
        var imSoldout = this.inventoryManager.isSoldout(this._item);
        result = (!this.isParent && imSoldout);
        var now = this.convertNowDateToStoreTimeZone(this.orderManager.store.timezone).getTime();
        // const now = Date.now();
        return result || !this.menuManager.isAvailableCombo(this.orderManager.store, this.category, this._item, this.orderManager.isTakeout(), now);
    };
    GridLayoutItem.prototype.convertNowDateToStoreTimeZone = function (timeZone) {
        timeZone = timeZone ? timeZone : 'GMT+8';
        var timeZoneValue = timeZone.split('GMT')[1];
        // let isPositive = timeZoneValue.startsWith('+');
        var integerTimeZoneValue = parseFloat(timeZoneValue);
        var now = new Date();
        now.setHours(now.getUTCHours() + integerTimeZoneValue);
        return now;
    };
    GridLayoutItem.prototype.removeClicked = function () {
        this.removeClick.emit(this._item);
    };
    GridLayoutItem.prototype.addClicked = function () {
        this.addClick.emit(this._item);
    };
    return GridLayoutItem;
}());
export { GridLayoutItem };
